/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  SearchBar: () => (/* binding */ SearchBar)
});

;// external "core-js/modules/es.error.cause.js"
const es_error_cause_js_namespaceObject = require("core-js/modules/es.error.cause.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.filter.js"
const esnext_iterator_filter_js_namespaceObject = require("core-js/modules/esnext.iterator.filter.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/ui/context/config-context.jsx


const ConfigContext = /*#__PURE__*/(0,external_react_namespaceObject.createContext)();
const ConfigProvider = props => {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(ConfigContext.Provider, {
    value: {
      config: props
    },
    children: props.children
  });
};
;// external "frontend-i18n"
const external_frontend_i18n_namespaceObject = require("frontend-i18n");
;// external "core-js/modules/es.array.iterator.js"
const es_array_iterator_js_namespaceObject = require("core-js/modules/es.array.iterator.js");
;// external "core-js/modules/es.promise.js"
const es_promise_js_namespaceObject = require("core-js/modules/es.promise.js");
;// external "core-js/modules/es.promise.finally.js"
const es_promise_finally_js_namespaceObject = require("core-js/modules/es.promise.finally.js");
;// external "core-js/modules/web.dom-collections.iterator.js"
const web_dom_collections_iterator_js_namespaceObject = require("core-js/modules/web.dom-collections.iterator.js");
;// external "react-dom"
const external_react_dom_namespaceObject = require("react-dom");
;// ./src/ui/components/SearchIconSvg/index.jsx


const SearchIconSvg = () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none",
  viewBox: "0 0 15 15",
  className: "searchbar-icon-search",
  children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
    fill: "#000",
    fillOpacity: "0.55",
    fillRule: "evenodd",
    d: "M9.997 10.846a6 6 0 11.849-.848l4.002 4-.849.85-4.002-4.002zM1.401 6.2a4.8 4.8 0 109.6 0 4.8 4.8 0 00-9.6 0z",
    clipRule: "evenodd"
  })
});
;// ./src/ui/components/SendIconSvg/index.jsx


const SendIconSvg = () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "currentColor",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.77963 1.94099C2.57484 1.83859 2.33045 1.85637 2.14264 1.98733C1.95483 2.11829 1.85366 2.34146 1.87894 2.56902L2.35009 7.77048C2.40475 8.37391 2.88431 8.85126 3.48799 8.90313L3.70075 8.9214L9.55482 9.40127C9.81918 9.48058 10.0002 9.7239 10.0002 9.99991C10.0002 10.2759 9.81918 10.5192 9.55482 10.5986L3.70075 11.0784L3.48799 11.0967C2.88431 11.1486 2.40475 11.6259 2.35009 12.2293L1.87894 17.431C1.85366 17.6585 1.95483 17.8817 2.14264 18.0127C2.33045 18.1436 2.57484 18.1614 2.77963 18.059L17.7796 10.559C17.9914 10.4531 18.1251 10.2367 18.1251 10C18.1251 9.76327 17.9914 9.54685 17.7796 9.44098L2.77963 1.94099Z",
    clipRule: "evenodd"
  })
});
;// ./src/ui/utils/debounce.js



const {
  useState,
  useEffect
} = (external_react_default());
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};
;// external "core-js/modules/es.promise.all-settled.js"
const es_promise_all_settled_js_namespaceObject = require("core-js/modules/es.promise.all-settled.js");
;// external "core-js/modules/es.regexp.exec.js"
const es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// external "core-js/modules/web.url-search-params.js"
const web_url_search_params_js_namespaceObject = require("core-js/modules/web.url-search-params.js");
;// external "core-js/modules/web.url-search-params.delete.js"
const web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// external "core-js/modules/web.url-search-params.has.js"
const web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// external "core-js/modules/web.url-search-params.size.js"
const web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// external "make-cancellable-promise"
const external_make_cancellable_promise_namespaceObject = require("make-cancellable-promise");
var external_make_cancellable_promise_default = /*#__PURE__*/__webpack_require__.n(external_make_cancellable_promise_namespaceObject);
;// external "core-js/modules/es.json.stringify.js"
const es_json_stringify_js_namespaceObject = require("core-js/modules/es.json.stringify.js");
;// external "core-js/modules/esnext.iterator.some.js"
const esnext_iterator_some_js_namespaceObject = require("core-js/modules/esnext.iterator.some.js");
;// ./src/sdk/clientStorage.ts



class ClientStorage {
  constructor(options) {
    this.memoryStorage = {};
    this.options = options;
  }
  get storage() {
    if (typeof window === 'undefined') {
      return {
        setItem: (storageKey, storageItem) => {
          this.memoryStorage[storageKey] = storageItem;
        },
        getItem: storageKey => {
          return this.memoryStorage[storageKey] || null;
        }
      };
    }
    return window[`${this.options.storageType}Storage`];
  }
  items() {
    const data = this.storage.getItem(this.options.storageKey);
    return JSON.parse(data || '[]');
  }
  push(newItem) {
    var _a, _b;
    if (!newItem) {
      return;
    }
    if ((!newItem.llm || !((_a = newItem.llm) === null || _a === void 0 ? void 0 : _a.answer)) && (!(newItem === null || newItem === void 0 ? void 0 : newItem.classic) || !((_b = newItem === null || newItem === void 0 ? void 0 : newItem.classic) === null || _b === void 0 ? void 0 : _b.length))) {
      return;
    }
    const items = this.items();
    const duplicated = items.some(item => (item === null || item === void 0 ? void 0 : item.query.text) === (newItem === null || newItem === void 0 ? void 0 : newItem.query.text));
    if (!duplicated) {
      const key = this.options.storageKey;
      const data = Array.prototype.concat([newItem], items);
      const value = JSON.stringify(data.slice(0, this.options.stackSize));
      this.storage.setItem(key, value);
    }
  }
}
;
;// external "core-js/modules/es.array.includes.js"
const es_array_includes_js_namespaceObject = require("core-js/modules/es.array.includes.js");
;// external "core-js/modules/es.string.replace.js"
const es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// external "markdown-it"
const external_markdown_it_namespaceObject = require("markdown-it");
var external_markdown_it_default = /*#__PURE__*/__webpack_require__.n(external_markdown_it_namespaceObject);
;// external "highlight.js"
const external_highlight_js_namespaceObject = require("highlight.js");
var external_highlight_js_default = /*#__PURE__*/__webpack_require__.n(external_highlight_js_namespaceObject);
;// ./src/sdk/introspection.ts






const BOT_NOT_UNDERSTAND = "\`\`\`bot_not_understand\`\`\`";
const introspection = {
  date() {
    return new Date().toISOString().replace('T', ' ').split('').slice(0, -2).join('');
  },
  product() {
    const common = ['docs', '-'];
    if (typeof window === 'undefined') {
      return common;
    }
    const productArray = window.location.pathname.split('/').filter(item => item).slice(2, 4);
    if (productArray.length < 1) {
      return common;
    }
    if (productArray.length === 1) {
      productArray.push('-');
    }
    if (productArray.length > 2) {
      return productArray.slice(0, 2);
    }
    return productArray;
  },
  location() {
    if (typeof window === 'undefined') {
      return JSON.stringify({
        href: 'unknown',
        origin: 'unknown'
      });
    }
    return JSON.stringify({
      href: window.location.href,
      origin: window.location.origin
    });
  },
  lang(path, quiet) {
    const DEFAULT_LANG = 'es';
    const VALID_LANGS = ['es', 'en', 'pt'];
    if (!path && typeof window === 'undefined') {
      return DEFAULT_LANG;
    }
    const pathname = path || window.location.pathname;
    const lang = pathname.split('/').filter(str => str).filter(item => VALID_LANGS.includes(item))[0];
    if (!quiet && !lang) {
      console.warn('Using default languague for VirtualAssistentSDK', DEFAULT_LANG);
    }
    return lang || DEFAULT_LANG;
  },
  getStrWords(str) {
    let minLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return (str || '').toLocaleLowerCase().normalize("NFKD").replace('__test:', '').replace(/[\u0300-\u036f]/g, "").replace(/[¿&\/\\#,+()$~%.'":*?<>{}]/g, '').split(' ').filter(word => word.length > minLen).join(' ').trim();
  }
};
;// ./src/sdk/markdown.ts






function linksToAnchor(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.replace(/(?<!href=")(?:(((ftp|https?):\/\/)(w{3}\.))[\-\w@:%_\+.~#?,&\/\/=]+)/g, url => {
    return `<a target="_blank" href="${url}">${url}</a>`;
  });
}
function normalizeLineBreaks(str) {
  return str.replace(/\\s*n/g, '\n');
}
function customTranformers(text) {
  return normalizeLineBreaks(linksToAnchor(text));
}
function copyButton(str) {
  const lang = introspection.lang();
  const label = {
    pt: 'Copiar',
    es: 'Copiar',
    en: 'Copy'
  };
  return `<button data-copy-snippet>${label[lang] || label.es}<template>${encodeURI(str)}</template></button>`;
}
function wrapPreCode(str, lang, rawStr) {
  const header = `
    <span class="pre-header">
      <span class="pre-header__left">
        <mark>${lang}</mark>
      </span>

      <span class="pre-header__right">
        ${copyButton(rawStr)}
      </span>
    </span>
  `;
  return `<pre class="hljs">${header}<code class="hljs language-${lang}">${str}</code></pre>`;
}
function addPreCodeLineNumbers(str) {
  const lines = (str || '').split('\n');
  const gutter = String(lines.length).length + 1;
  return lines.map((line, index) => `<span data-line-number style="min-width: ${gutter}ch">${index + 1}</span>${line}`).join('\n');
}
function useHighlighter() {
  return {
    langPrefix: 'hljs language-',
    highlight: (str, lang) => {
      if (lang && external_highlight_js_default().getLanguage(lang)) {
        try {
          const highlighted = external_highlight_js_default().highlight(str, {
            language: lang,
            ignoreIllegals: true
          });
          highlighted.value = addPreCodeLineNumbers(highlighted.value);
          return wrapPreCode(highlighted.value, lang, str);
        } catch (error) {
          console.error(error);
        }
      }
      return wrapPreCode(str, lang, str);
    }
  };
}
function md(text) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!text || typeof text !== 'string' || text === BOT_NOT_UNDERSTAND) {
    return '';
  }
  const parser = external_markdown_it_default()((options === null || options === void 0 ? void 0 : options.highlightPreCode) ? useHighlighter() : {});
  const parsed = parser.render(text);
  const result = customTranformers(parsed);
  return result;
}
;// ./src/sdk/mocks.ts





var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};


const mockedId = 'bc03f4ea-f1d2-478b-a100-c0d15d47c7cd';
const mockedClassicResults = [{
  "content": "---\ncontent_section_with_media: \n - title: Checkout Bricks\n - message: O Checkout Bricks é um conjunto de módulos de interface do usuário que já vêm prontos para o front-end e são otimizados para uma melhor usabilidade e conversão. Cada Brick pode ser utilizado de forma independente ou em conjunto, formando a experiência de um checkout completo.\n - media_video: https://www.youtube.com/embed/jv9oCydWV78\n---\n\n---\nbullet_section_with_media: \n - title: \n - type: normal\n - message: Oferece uma experiência de checkout transparente com possibilidade de customização de acordo com cada loja e é seguro porque as informações de pagamento são processadas através do Mercado Pago, possuindo um processo de integração mais simples que minimiza o tempo de produção e desenvolvimento.\n - image:/checkout-bricks/cho-bricks-landing-v4.png\n---\n\n--- mini_landing_separator ---\n\n>>>> Disponibilidade por país <<<<\n---\navailable_countries: mla, mlb, mlm, mlu, mlc, mco, mpe\n\n---\n\n--- mini_landing_separator ---\n\n---\nfuture_product_avaible: \n - title: Bricks\n - description: Conheça todos os módulos do Checkout Bricks e as suas disponibilidades.\n - card_avaible: true\n - card_icon: Card\n - card_title: Card Payment Brick\n - card_description: Ofereça pagamentos com cartão de crédito e débito. Teste a demonstração do Brick antes de integrá-lo.\n - card_link: /developers/pt/docs/checkout-bricks/card-payment-brick/introduction\n - card_linkDescription: Saiba mais\n - card_pillText: DISPONÍVEL\n - card_avaible: true\n - card_icon: Pay\n - card_title: Payment Brick\n - card_description: Ofereça diferentes métodos de pagamento para os clientes escolherem, com a capacidade de salvar detalhes do cartão para compras futuras. Teste a demonstração do Brick antes de integrá-lo.\n - card_link: /developers/pt/docs/checkout-bricks/payment-brick/introduction\n - card_linkDescription: Saiba mais\n - card_pillText: DISPONÍVEL\n - card_avaible: true\n - card_icon: Loading\n - card_title: Status Screen Brick\n - card_description: Informe os clientes dos resultados do processo de compra após efetuar o pagamento. Teste a demonstração do Brick antes de integrá-lo.\n - card_link: /developers/pt/docs/checkout-bricks/status-screen-brick/introduction\n - card_linkDescription: Saiba mais\n - card_pillText: DISPONÍVEL\n - card_avaible: true\n - card_icon: Wallet\n - card_title: Wallet Brick\n - card_description: Vincule a conta Mercado Pago e permita pagamentos registrados. Teste a demonstração do Brick antes de integrá-lo.\n - card_link: /developers/pt/docs/checkout-bricks/wallet-brick/introduction\n - card_linkDescription: Saiba mais\n - card_pillText: DISPONÍVEL\n - card_avaible: false\n - card_icon: User\n - card_title: User Info Brick\n - card_description: Colete os dados dos clientes para deduzir aqueles que serão necessários no processo de compra.\n - card_link:\n - card_linkDescription:\n - card_pillText: EM BREVE\n - card_avaible: false\n - card_icon: Truck\n - card_title: Shipping Brick\n - card_description: Colete dados de envio dos clientes e exiba as opções de entrega disponíveis, além de seus benefícios.\n - card_link:\n - card_linkDescription:\n - card_pillText: EM BREVE\n - card_avaible: false\n - card_icon: Check\n - card_title: Review & Confirm Brick\n - card_description: Exiba um resumo de todo o processo de compra com as informações mais relevantes, assim os clientes poderão analisar antes de confirmar a compra.\n - card_link:\n - card_linkDescription:\n - card_pillText: EM BREVE\n---\n\n--- mini_landing_separator ---\n>>>> Tipos de pagamento aceitos <<<<\n\n----[mlb]----\n\n---\navailable_payments: credit, debit, mercadopago, boleto, pix, pec\n\n---\n\n------------\n\n----[mla]---- \n\n---\navailable_payments: credit, debit, mercadopago, rapipago, pagofacil\n\n---\n------------\n\n----[mlm]---- \n\n---\navailable_payments: credit, debit, mercadopago, efectivo, atm\n\n---\n------------\n\n----[mlu]---- \n\n---\navailable_payments: credit, debit, mercadopago\n\n---\n------------\n\n----[mco]---- \n\n---\navailable_payments: credit, debit, mercadopago, efectivo, pse\n\n---\n------------\n\n----[mlc]---- \n\n---\navailable_payments: credit, debit, mercadopago\n\n---\n------------\n\n----[mpe]---- \n\n---\navailable_payments: credit, debit, mercadopago, atm\n\n---\n------------\n\n> Para detalhes dos meios de pagamento aceitos em cada país, verifique a lista completa com a [disponibilidade de meios de pagamento.](/developers/pt/docs/sales-processing/payment-methods)",
  "docPath": "guides/checkout-bricks/landing",
  "url": "/docs/checkout-bricks/landing",
  "score": 0,
  "title": "Checkout Bricks",
  "section": "Checkout Bricks",
  "highlight": ":\n - card_linkDescription:\n - card_pillText: EM BREVE\n - card_avaible: false\n - card_icon: <b>Check</b>\n - card_title"
}, {
  "content": "# Instalação via Adobe Commerce (Magento) Marketplace\n\nAtravés da loja Adobe Commerce (Magento), você pode instalar gratuitamente o modulo do Mercado Pago de forma muito simples. Para isso, siga os passos abaixo.\n\n1. Acesse a [Loja Oficial Adobe Commerce (Magento)](https://marketplace.magento.com/). No mecanismo de busca, você deve colocar Mercado Pago e selecionar [a extensão oficial](https://commercemarketplace.adobe.com/mercadopago-adb-payment.html).\n2. Abra o menu **Edition** e selecione a edição necessária do modulo. Em seguida, abra o menu **Sua versão da loja** e selecione o tipo de versão de que você precisa para o seu negócio. Por fim, clique em **Adicionar ao carrinho** para adicionar o modulo ao carrinho.\n3. Clique no carrinho no canto superior direito do site e, em seguida, clique em **Prosseguir para o check-out** para finalizar a sua compra.\n4. Para continuar, você deve fazer o login com sua conta Adobe Commerce (Magento) ou criar uma nova. Uma vez cadastrado, você pode baixar o modulo Mercado Pago e instalá-lo.\n\nPronto! Você instalou com sucesso o modulo Mercado Pago para Adobe Commerce (Magento).",
  "docPath": "guides/adobe-commerce/installation-magento-marketplace",
  "url": "/docs/adobe-commerce/installation/magento-marketplace",
  "score": 0,
  "title": "Instalação via Adobe Commerce (Magento)",
  "section": "Adobe Commerce (Magento)",
  "highlight": ", clique em **Prosseguir para o <b>check</b>-out** para finalizar a sua compra.\n4. Para continuar, você deve"
}];
const mockCodeSnippet = (/* unused pure expression or super */ null && (`
  \`\`\`php
  <?php
  $client = new PreferenceClient();
  $preference = $client->create([
    "items"=>array(
      array(
        "title" => "Mi producto",
        "quantity" => 1,
        "unit_price" => 4500
      )
    )
  ]);
`));
const mockedLLMResults = {
  id: mockedId,
  answer: `Claro, aquí tienes los links para la documentación de los SDKs server-side de Mercado Pago:

  - **PHP**:
  - [Packagist](https://packagist.org/packages/mercadopago/dx-php)
  - [GitHub](https://github.com/mercadopago/sdk-php)
  
  - **Java**:
  - [Maven](https://search.maven.org/artifact/com.mercadopago/sdk-java)
  - [GitHub](https://github.com/mercadopago/sdk-java)
  
  - **NodeJS**:
  - [NPM](https://www.npmjs.com/package/mercadopago)
  - [GitHub](https://github.com/mercadopago/sdk-nodejs)
  
  - **Ruby**:
  - [Gem](https://rubygems.org/gems/mercadopago-sdk)
  - [GitHub](https://github.com/mercadopago/sdk-ruby)
  
  - **.NET**:
  - [NuGet](https://www.nuget.org/packages/mercadopago-sdk)
  - [GitHub](https://github.com/mercadopago/sdk-dotnet)
  
  - **Python**:
  - [PyPI](https://pypi.org/project/mercadopago/)
  - [GitHub](https://github.com/mercadopago/sdk-python)
  
  - **Go**:
  - [Go](https://pkg.go.dev/github.com/mercadopago/sdk-go)
  - [GitHub](https://github.com/mercadopago/sdk-go)
  
  Puedes encontrar más detalles sobre la instalación, requisitos previos y primeros pasos en los enlaces proporcionados.`,
  min_words: false,
  is_ambiguous: false
};
function mockAnswer(query, options) {
  return __awaiter(this, void 0, void 0, function* () {
    const question = query.text;
    const defaultDelay = 500;
    const timeoutDelay = 5000;
    return new Promise((resolve, reject) => {
      if (question.includes('__test:error')) {
        setTimeout(() => reject(new Error('Unexpected Error')), defaultDelay);
        return;
      }
      if (question.includes('__test:timeout')) {
        setTimeout(() => reject(new Error('Promise Timedout')), timeoutDelay);
        return;
      }
      const result = {
        query,
        mock: true,
        llm: Object.assign(Object.assign({}, mockedLLMResults), {
          min_words: query.words.length < 3
        }),
        classic: [...mockedClassicResults]
      };
      if (result.llm.answer !== BOT_NOT_UNDERSTAND) {
        result.llm.html = md(result.llm.answer, options);
      }
      if (question.includes('__test:empty')) {
        result.llm.answer = BOT_NOT_UNDERSTAND;
        result.llm.html = '';
        result.classic = [];
      }
      if (question.includes('__test:ambiguous')) {
        result.llm.is_ambiguous = true;
        result.llm.answer = 'A pergunta feita não tem informações o suficiente para eu dar uma reposta precisa. Reformule-a ou dê mais detalhes para que eu possa ajudar você da melhor maneira possível. \nAlgumas sugestões de buscas que você pode fazer:';
        result.llm.html = '<p>A pergunta feita não tem informações o suficiente para eu dar uma reposta precisa. Reformule-a ou dê mais detalhes para que eu possa ajudar você da melhor maneira possível.</p> <p>Algumas sugestões de buscas que você pode fazer:</p>';
      }
      setTimeout(() => resolve(result), defaultDelay);
    });
  });
}
function mockFeedback() {
  return __awaiter(this, arguments, void 0, function () {
    let mock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'success';
    return function* () {
      const delay = mock === 'timeout' ? 5000 : 500;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (!mock || mock === 'success') {
            resolve({
              feedback: "200",
              id: "bc03f4ea-f1d2-478b-a100-c0d15d47c7cd"
            });
          }
          if (mock === 'error') {
            reject({
              feedback: "500",
              message: "Unexpected Error"
            });
          }
          if (mock === 'timeout') {
            reject({
              feedback: "503",
              message: "Promise Timedout"
            });
          }
        }, delay);
      });
    }();
  });
}
;// ./src/sdk/httpClient.ts




var httpClient_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

function request(mode, data, instanceOptions) {
  return httpClient_awaiter(this, void 0, void 0, function* () {
    var _a;
    const httpClient = (_a = instanceOptions.httpClients) === null || _a === void 0 ? void 0 : _a[mode];
    const lang = instanceOptions === null || instanceOptions === void 0 ? void 0 : instanceOptions.lang;
    if (!httpClient) {
      throw new Error('No HTTPClient available to classic search on "Dx Virtual Assistent SDK"');
    }
    if (!lang) {
      throw new Error('No language defined for the "Dx Virtual Assistent SDK", please set a "lang" option on your instance');
    }
    return httpClient(data, lang);
  });
}
function search(query, instanceOptions) {
  return httpClient_awaiter(this, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
      const llmSearchRequest = request('llm', query, instanceOptions);
      const classicSearchRequest = request('classic', query, instanceOptions);
      Promise.all([llmSearchRequest, classicSearchRequest]).then(results => {
        var _a;
        resolve({
          query,
          classic: results[1],
          llm: Object.assign(Object.assign({}, results[0] || {}), {
            html: md((_a = results[0]) === null || _a === void 0 ? void 0 : _a.answer, instanceOptions)
          })
        });
      }).catch(reject);
    });
  });
}
function feedback(data, instanceOptions) {
  return httpClient_awaiter(this, void 0, void 0, function* () {
    return request('feedback', data, instanceOptions);
  });
}
;// ./src/sdk/dom.ts



var dom_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function injectStyleElement(id, rawStyle) {
  return dom_awaiter(this, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
      if (typeof window === 'undefined' || typeof document === 'undefined' || !id || !rawStyle) {
        return reject(false);
      }
      ;
      if (!document.getElementById(id)) {
        const style = Object.assign(document.createElement('style'), {
          id,
          innerHTML: rawStyle
        });
        document.body.appendChild(style);
        resolve(true);
      }
      ;
    });
  });
}
function createToast(innerText, color) {
  void injectStyleElement('virtual-assistent-sdk-toast-css', `
    .virtual-assistent-sdk-toast {
      background-color: blue;
      color: #fff;
      position: fixed;
      bottom: 0px;
      left: 50%;
      padding: 16px 24px;
      border-radius: 5px;
      display: block;
      box-sizing: border-box;
      transform: translateX(-50%);
      height: 48px;
      animation: virtual-assistent-sdk-toast-show 100ms forwards;
      display: flex;
      align-items: center;
    }

    @keyframes virtual-assistent-sdk-toast-show {
      from {
        opacity: 0;
        visibility: hidden;
        bottom: 0;
      }
      to {
        opacity: 1;
        visibility: visible;
        bottom: 50px;
      }
    }
  `);
  const box = Object.assign(document.createElement('div'), {
    innerText,
    classList: 'virtual-assistent-sdk-toast',
    style: `background-color: ${color}`,
    onclick: () => box.remove()
  });
  setTimeout(() => {
    box.remove();
  }, 3000);
  document.body.appendChild(box);
}
const toast = {
  success: msg => createToast(msg, 'green'),
  error: msg => createToast(msg, 'red')
};
function transformHighlightedPreCode(elements) {
  elements.querySelectorAll('pre').forEach(pre => {
    try {
      const content = pre.cloneNode(true);
      const shadowed = document.createElement('div');
      shadowed.attachShadow({
        mode: 'open'
      });
      const style = Object.assign(document.createElement('style'), {
        innerHTML: `
          .hljs {
            color: #c9d1d9;
            background: #333;
            font-family: "Proxima Nova", "Helvetica Neue", Helvetica, Arial, sans-serif;
          }
          pre code.hljs {
            display: block;
            overflow-x: auto;
            padding: 1em
          }
          code.hljs {
            padding: 3px 5px
          }
          /*!
            Theme: GitHub Dark
            Description: Dark theme as seen on github.com
            Author: github.com
            Maintainer: @Hirse
            Updated: 2021-05-15

            Outdated base version: https://github.com/primer/github-syntax-dark
            Current colors taken from GitHub's CSS
          */
          .hljs-doctag,
          .hljs-keyword,
          .hljs-meta .hljs-keyword,
          .hljs-template-tag,
          .hljs-template-variable,
          .hljs-type,
          .hljs-variable.language_ {
            /* prettylights-syntax-keyword */
            color: #ff7b72
          }
          .hljs-title,
          .hljs-title.class_,
          .hljs-title.class_.inherited__,
          .hljs-title.function_ {
            /* prettylights-syntax-entity */
            color: #d2a8ff
          }
          .hljs-attr,
          .hljs-attribute,
          .hljs-literal,
          .hljs-meta,
          .hljs-number,
          .hljs-operator,
          .hljs-variable,
          .hljs-selector-attr,
          .hljs-selector-class,
          .hljs-selector-id {
            /* prettylights-syntax-constant */
            color: #79c0ff
          }
          .hljs-regexp,
          .hljs-string,
          .hljs-meta .hljs-string {
            /* prettylights-syntax-string */
            color: #a5d6ff
          }
          .hljs-built_in,
          .hljs-symbol {
            /* prettylights-syntax-variable */
            color: #ffa657
          }
          .hljs-comment,
          .hljs-code,
          .hljs-formula {
            /* prettylights-syntax-comment */
            color: #8b949e
          }
          .hljs-name,
          .hljs-quote,
          .hljs-selector-tag,
          .hljs-selector-pseudo {
            /* prettylights-syntax-entity-tag */
            color: #7ee787
          }
          .hljs-subst {
            /* prettylights-syntax-storage-modifier-import */
            color: #c9d1d9
          }
          .hljs-section {
            /* prettylights-syntax-markup-heading */
            color: #1f6feb;
            font-weight: bold
          }
          .hljs-bullet {
            /* prettylights-syntax-markup-list */
            color: #f2cc60
          }
          .hljs-emphasis {
            /* prettylights-syntax-markup-italic */
            color: #c9d1d9;
            font-style: italic
          }
          .hljs-strong {
            /* prettylights-syntax-markup-bold */
            color: #c9d1d9;
            font-weight: bold
          }
          .hljs-addition {
            /* prettylights-syntax-markup-inserted */
            color: #aff5b4;
            background-color: #033a16
          }
          .hljs-deletion {
            /* prettylights-syntax-markup-deleted */
            color: #ffdcd7;
            background-color: #67060c
          }
          .hljs-char.escape_,
          .hljs-link,
          .hljs-params,
          .hljs-property,
          .hljs-punctuation,
          .hljs-tag {
            /* purposely ignored */

          }
          /* custom */
          pre.hljs {
            padding: 0;
            margin: 0;
            margin-bottom: 16px;
            min-height: unset;
            max-height: 300px;
            border: none ;
            border-radius: 8px;
            overflow: hidden;
            position: relative;
            display: flex;
            flex-direction: column;
            font-size: 12px;
            background-color: #eeee
          }
          pre.hljs .pre-header {
            width: 100%;
            min-height: 54px;
            background-color: #eeee;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            box-sizing: border-box;
          }
          pre.hljs .pre-header > span {
            display: flex;
            align-items: center;
            height: 100%;
          }
          pre.hljs .pre-header mark {
            all: unset;
            appearance: none;
            background-color: transparent;
            text-align: left;
            display: block;
            color: #666;
            text-transform: capitalize;
            font-size: 12px;
            font-weight: 600;
          }
          pre.hljs .pre-header button {
            height: 40px;
            background: none;
            padding: 0 14px 0;
            color: var(--andes-color-blue-500, #3483fa);
            border: 1px solid var(--andes-color-blue-500, #3483fa);
            min-width: 40px;
            min-height: 40px;
            font-size: .875em;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 0.25em;
            border-width: .05556em
            line-height: 2.55556;
            font-weight: 300;
          }
          pre.hljs .pre-header button[data-copy-snippet]:hover {
            transition: background 75ms linear, color 75ms linear, border 75ms linear;
            background-color: var(--andes-color-blue-500, #3483fa);
            color: white;
          }
          pre.hljs code {
            flex: 1;
            font-family: monospace;
          }
          [data-line-number] {
            display: inline-block;
            position: relative;
            margin-right: 1ch;
            color: #8b949e;
            font-size: 14px;
            user-select: none;
          }
          [data-line-number]:after {
            content: '';
            position: absolute;
            right: 0;
            height: calc(100% + 2px);
            border-right: solid 1px #666;
          }
          pre code.hljs a {
            color: #c2cad1;
          }
        `
      });
      if (shadowed.shadowRoot) {
        shadowed.shadowRoot.append(content);
        if (style) {
          shadowed.shadowRoot.append(style.cloneNode(true));
        }
        shadowed.shadowRoot.querySelectorAll('pre [data-copy-snippet]').forEach(copyBtn => {
          copyBtn.addEventListener('click', () => {
            var _a;
            const snippet = decodeURI(((_a = copyBtn.querySelector('template')) === null || _a === void 0 ? void 0 : _a.content.textContent) || '');
            try {
              void navigator.clipboard.writeText(snippet);
              toast.success('Copiado com sucesso');
            } catch (error) {
              console.error(error);
              toast.error('Não foi possível copiar os dados. Por gentileza copie manualmente');
            }
          });
        });
      }
      pre.replaceWith(shadowed);
    } catch (error) {
      console.error(error);
    }
  });
}
function fadeIn(el, speed) {
  let opacity = 0;
  const animation = setInterval(() => {
    opacity += 0.2;
    el.style.opacity = String(opacity);
    if (opacity >= 1) {
      clearInterval(animation);
    }
  }, speed);
}
function informProgress(speed, length, cb) {
  const totalTimeMs = speed * length;
  const step = totalTimeMs / 100;
  let current = 0;
  if (!step) {
    return false;
  }
  const reporter = setInterval(() => {
    ++current;
    if (cb) {
      cb(current);
    }
    if (current >= 100) {
      clearInterval(reporter);
    }
  }, step);
  return true;
}
function fader(target, content, cb) {
  let speed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 250;
  try {
    while (target.lastChild) {
      target.lastChild.remove();
    }
    const nodes = content.childNodes;
    informProgress(speed, nodes.length, cb);
    nodes.forEach((node, index) => {
      if (node.style) {
        node.style.opacity = '0';
      }
      setTimeout(() => {
        target.append(node);
        if (node.style) {
          fadeIn(node, 100);
        }
      }, speed * index);
    });
  } catch (error) {
    console.error(error);
    if (target && (target === null || target === void 0 ? void 0 : target.append)) {
      target.innerHTML = '';
      target.append(content);
    }
  }
}
function main(innerHTML, options) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const template = document.createElement('template');
  try {
    Object.assign(template, {
      innerHTML
    });
  } catch (error) {
    console.error(error);
  }
  if (options.highlightPreCode) {
    transformHighlightedPreCode(template.content);
  }
  return template.content;
}
;// ./src/sdk/index.ts




var sdk_awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};







class DxVirtualAssistent {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = options;
    this.cache = this.initializeCache(options.cache);
    this.debug('Instance created with options:', this.options);
  }
  ask(question, options) {
    const cp = external_make_cancellable_promise_default()(new Promise((resolve, reject) => {
      if (!question || !question.trim()) {
        this.debug('Error: No question provided for LLM');
        reject(new Error('No question provided'));
        return;
      }
      ;
      const query = this.createQuery(question, options);
      this.debug('Query created:', query);
      if (question.toLowerCase().trim().startsWith('__test:')) {
        this.createMockedResult(query).then(result => {
          this.debug('Result given: ', result);
          return resolve(result);
        }).catch(error => {
          this.debug('Answer error:', error);
          return reject(error);
        });
        return;
      }
      this.debug('Asking to Search API for the query: ', query);
      search(query, this.options).then(result => {
        this.cache.push(result);
        this.debug('Result given: ', result);
        return resolve(result);
      }).catch(error => {
        this.debug('Answer error:', error);
        return reject(error);
      });
    }));
    return {
      question: cp.promise,
      cancel: () => {
        this.debug('Question cancelled: ', question);
        cp.cancel();
      }
    };
  }
  getQuestionWords(str) {
    return introspection.getStrWords(str);
  }
  createQuery(question, options) {
    var _a;
    return {
      lang: ((_a = this.options) === null || _a === void 0 ? void 0 : _a.lang) || introspection.lang(),
      text: question,
      date_created: introspection.date(),
      site: this.options.site || '',
      words: this.getQuestionWords(question),
      location: introspection.location(),
      product: this.options.product || introspection.product(),
      was_suggestion: (options === null || options === void 0 ? void 0 : options.was_suggestion) || false
    };
  }
  createMockedResult(query) {
    return sdk_awaiter(this, void 0, void 0, function* () {
      this.debug('Identified test question: __test: <question>. The answer will be a mock, no real API request added.');
      return mockAnswer(query, this.options);
    });
  }
  feedback(id, positive, mock) {
    return sdk_awaiter(this, void 0, void 0, function* () {
      if (mock) {
        this.debug('Called mocked feedback request. Mock type: ', mock);
        return mockFeedback(mock);
      }
      this.debug(`Called ${positive ? 'positive' : 'negative'} feedback request for: `, id);
      return feedback({
        id,
        feedback: positive
      }, this.options);
    });
  }
  initializeCache(cacheOptions) {
    return new ClientStorage(Object.assign({
      stackSize: 5,
      storageType: 'local',
      storageKey: '__DXSEARCHASSISTENTSDK000__'
    }, cacheOptions || {}));
  }
  searchHistory() {
    return this.cache.items();
  }
  debug() {
    var _a;
    if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.debug) {
      for (var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++) {
        message[_key] = arguments[_key];
      }
      console.trace('[🤖 DX Virtual Assistent SDK]: ', ...message);
    }
    ;
  }
  renderAnswerAI(html, options) {
    if (options === null || options === void 0 ? void 0 : options.md) {
      return this.renderAnswerAI(md(html, this.options), Object.assign(options, {
        md: false
      }));
    }
    const content = main(html, this.options);
    const {
      target
    } = options || {};
    if (target && (target === null || target === void 0 ? void 0 : target.append)) {
      if (options === null || options === void 0 ? void 0 : options.fader) {
        const {
          speed,
          onProgress
        } = options.fader;
        fader(target, content, onProgress, speed || 250);
      } else {
        while (target.lastChild) {
          target.lastChild.remove();
        }
        target.append(content);
      }
    }
    return content;
  }
}

;// external "core-js/modules/es.symbol.description.js"
const es_symbol_description_js_namespaceObject = require("core-js/modules/es.symbol.description.js");
;// external "dx-devsite-markdown"
const external_dx_devsite_markdown_namespaceObject = require("dx-devsite-markdown");
;// external "markdown-to-txt"
const external_markdown_to_txt_namespaceObject = require("markdown-to-txt");
;// ./src/ui/utils/parse-result-item.js





function extractMessageFromHTML(title, innerHTML, size) {
  try {
    var _parts$0$trim, _title$trim;
    const raw = Object.assign(document.createElement('template'), {
      innerHTML
    }).content.textContent.trim();
    const parts = (raw || '').split(/(\r\n|\n|\r)/gm);
    const mustRemoveTitle = parts.length > 1 && ((_parts$0$trim = parts[0].trim()) === null || _parts$0$trim === void 0 ? void 0 : _parts$0$trim.toLocaleLowerCase) === ((_title$trim = title.trim()) === null || _title$trim === void 0 ? void 0 : _title$trim.toLocaleLowerCase);
    const pre = (mustRemoveTitle ? parts.slice(1) : parts[0]).join(' ').trim();
    return (0,external_markdown_to_txt_namespaceObject.markdownToTxt)(pre).substring(0, size).replace(/ *\[[^)]*\] */g, '');
  } catch (error) {
    console.error(error);
    return '...';
  }
}
function parseResultItem(result, lang, siteId) {
  if (!result) {
    return null;
  }
  try {
    var _result$item;
    const {
      paths
    } = JSON.parse((result === null || result === void 0 ? void 0 : result.body) || '{}');
    const title = (result === null || result === void 0 ? void 0 : result.title) || (result === null || result === void 0 || (_result$item = result.item) === null || _result$item === void 0 ? void 0 : _result$item.title);
    const endpoint = ((result === null || result === void 0 ? void 0 : result.url) || '').startsWith(`/developers/${lang}/`) ? result.url : `/developers/${lang}${result.url}`;
    let message = '';
    result.title = title;
    if (result.body && paths) {
      var _methods$Object$keys$;
      const methods = Object.keys(paths || {}).length ? paths[Object.keys(paths)[0]] : [];
      message = ((_methods$Object$keys$ = methods[Object.keys(methods)[0]]) === null || _methods$Object$keys$ === void 0 ? void 0 : _methods$Object$keys$.description) || '';
    } else {
      message = extractMessageFromHTML(result === null || result === void 0 ? void 0 : result.title, external_dx_devsite_markdown_namespaceObject.Library.Parser(result === null || result === void 0 ? void 0 : result.content, siteId, lang), 200);
    }
    if (message && typeof message === 'object') {
      message = message[lang] || '';
    }
    return {
      title,
      message,
      endpoint,
      docPath: result === null || result === void 0 ? void 0 : result.docPath,
      section: result === null || result === void 0 ? void 0 : result.section
    };
  } catch (error) {
    console.trace('Could not show search result item: ', result, error);
    return null;
  }
}
;
;// external "core-js/modules/es.set.difference.v2.js"
const es_set_difference_v2_js_namespaceObject = require("core-js/modules/es.set.difference.v2.js");
;// external "core-js/modules/es.set.intersection.v2.js"
const es_set_intersection_v2_js_namespaceObject = require("core-js/modules/es.set.intersection.v2.js");
;// external "core-js/modules/es.set.is-disjoint-from.v2.js"
const es_set_is_disjoint_from_v2_js_namespaceObject = require("core-js/modules/es.set.is-disjoint-from.v2.js");
;// external "core-js/modules/es.set.is-subset-of.v2.js"
const es_set_is_subset_of_v2_js_namespaceObject = require("core-js/modules/es.set.is-subset-of.v2.js");
;// external "core-js/modules/es.set.is-superset-of.v2.js"
const es_set_is_superset_of_v2_js_namespaceObject = require("core-js/modules/es.set.is-superset-of.v2.js");
;// external "core-js/modules/es.set.symmetric-difference.v2.js"
const es_set_symmetric_difference_v2_js_namespaceObject = require("core-js/modules/es.set.symmetric-difference.v2.js");
;// external "core-js/modules/es.set.union.v2.js"
const es_set_union_v2_js_namespaceObject = require("core-js/modules/es.set.union.v2.js");
;// ./src/ui/utils/dedup-classic-search.js













/**
 * Somethings itens from de classic search API can be duplicated, or with differente
 * endpoints but pointing to the exact same document view (doc). This function deduplicates it
 */
function dedupByDocPaths(arr) {
  const filtered = [];
  arr.forEach(item => {
    try {
      if (item && typeof item === 'object') {
        const docPath = item === null || item === void 0 ? void 0 : item.docPath;
        const seenItem = docPath && filtered.find(x => x.docPath === docPath);
        if (!docPath || !seenItem) {
          filtered.push(item);
        }
      }
    } catch (error) {
      console.error(error);
    }
  });
  return filtered;
}

/**
 * The classic search has a bug which is returning duplicated items.
 * This may take a while to be solved by the backend. As a temporary fix
 * we will deduplicate the items on the client.
 */

const dedupClassicSearchItems = function (arr) {
  let dedupDocPaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const preFilter = Array.from(new Set(arr.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
  return dedupDocPaths ? dedupByDocPaths(preFilter) : preFilter;
};
;// ./src/ui/hooks/useConfig.jsx


const useConfig = () => {
  return (0,external_react_namespaceObject.useContext)(ConfigContext);
};
;// ./src/ui/hooks/useSearchClient.jsx
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


















function useSearchClient() {
  const {
    config
  } = useConfig();
  const httpClient = config.HTTPClient;
  const SearchAPI = {
    classic: {
      async search(query) {
        const {
          words,
          lang,
          site
        } = query;
        const payload = {
          params: {
            term: words
          }
        };
        const request = async (url, delay) => {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve(httpClient.get(url, payload));
            }, delay || 0);
          });
        };
        return Promise.allSettled([request(config.endpoints.references), request(config.endpoints.searchdocs, 300)]).then(data => {
          var _data$, _data$2;
          const results = [...((data === null || data === void 0 || (_data$ = data[0]) === null || _data$ === void 0 || (_data$ = _data$.value) === null || _data$ === void 0 ? void 0 : _data$.data) || []), ...((data === null || data === void 0 || (_data$2 = data[1]) === null || _data$2 === void 0 || (_data$2 = _data$2.value) === null || _data$2 === void 0 ? void 0 : _data$2.data) || [])].map(item => parseResultItem(item, lang, site)).filter(item => item);
          return dedupClassicSearchItems(results);
        });
      }
    },
    llm: {
      async ask(query) {
        const params = new URLSearchParams(query).toString();
        return httpClient.get(`${config.endpoints.ask}?${params}`);
      },
      async feedback(data) {
        const params = new URLSearchParams(data).toString();
        return httpClient.get(`${config.endpoints.feedback}?${params}`);
      }
    },
    assistent: function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const httpClients = {
        classic: async (query, lang) => SearchAPI.classic.search(query, lang),
        feedback: async data => SearchAPI.llm.feedback(data).then(result => result.data),
        llm: async query => {
          const isAIEnabled = SearchAPI.isAIEnabled(options.site);
          return isAIEnabled ? SearchAPI.llm.ask(query).then(result => {
            return result.data;
          }) : SearchAPI.requestNOOP();
        }
      };
      if (options.noClassicSearch) {
        httpClients.classic = async () => Promise.resolve({});
      }
      return new DxVirtualAssistent(_objectSpread(_objectSpread({}, options), {}, {
        httpClients,
        highlightPreCode: true
      }));
    },
    userSearchHistory: () => {
      return SearchAPI.assistent().searchHistory();
    },
    isAIEnabled: (/* site */
    ) => {
      // if want to allow only specific site id's
      // return ['MLC', 'MLU', 'MPE', 'MCO', 'MLM'].includes(site);
      return true;
    },
    async requestNOOP() {
      return Promise.resolve({});
    }
  };
  return SearchAPI;
}
;// ./src/ui/components/SearchInput/index.jsx









const SearchInput = _ref => {
  let {
    siteId,
    onTyped,
    onFocus,
    layout,
    name,
    onBlur,
    isActive,
    onSubmit,
    maxLength,
    placeholder,
    allowSearching
  } = _ref;
  const {
    isAIEnabled
  } = useSearchClient();
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const [searchText, setSearchText] = (0,external_react_namespaceObject.useState)('');
  const [isButtonDisabled, setIsButtonDisabled] = (0,external_react_namespaceObject.useState)(true);
  const debounceDelay = isAIEnabled(siteId) ? 200 : 600;
  const term = useDebounce(searchText, debounceDelay);
  (0,external_react_namespaceObject.useEffect)(() => {
    const phrase = (term === null || term === void 0 ? void 0 : term.trim()) || '';
    if (onTyped) {
      onTyped(phrase);
    }
    setIsButtonDisabled(!allowSearching);
  }, [term, allowSearching]);
  const submit = e => {
    e.preventDefault();
    const phrase = (term === null || term === void 0 ? void 0 : term.trim()) || '';
    if (onSubmit) {
      onSubmit(phrase);
    }
  };
  const getPlaceholder = () => {
    if (placeholder) {
      return placeholder;
    }
    if (layout === 'fixed') {
      return isAIEnabled(siteId) ? i18n.gettext('Ej.: cómo probar mi integración') : i18n.gettext('Buscar');
    }
    return isAIEnabled(siteId) ? i18n.gettext('Ejemplo: cómo probar mi integración') : i18n.gettext('Buscar una documentación');
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
      className: "search-input-container",
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchIconSvg, {}), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("form", {
        onSubmit: submit,
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("input", {
          maxLength: maxLength,
          value: searchText,
          name: name || 'ai-search-input',
          autoComplete: "off",
          tabIndex: 0,
          placeholder: getPlaceholder(),
          onInput: _ref2 => {
            let {
              target
            } = _ref2;
            return setSearchText(target.value);
          },
          onBlur: e => {
            if (onBlur) {
              onBlur(e);
            }
          },
          onFocus: e => {
            if (onFocus) {
              onFocus(e);
            }
          }
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("button", {
          disabled: isButtonDisabled,
          className: "searchbar-button-send",
          hidden: !isAIEnabled(siteId) || !isActive,
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SendIconSvg, {})
        })]
      })]
    })
  });
};
;// external "@andes/progress-indicator-circular"
const progress_indicator_circular_namespaceObject = require("@andes/progress-indicator-circular");
;// ./src/ui/components/LoadingSpinner/index.jsx



const LoadingSpinner = _ref => {
  let {
    height
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    style: {
      height: height || 200,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(progress_indicator_circular_namespaceObject.ProgressIndicatorCircular, {
      size: "medium",
      className: "spinner_test"
    })
  });
};
;// external "@andes/icons/Info16"
const Info16_namespaceObject = require("@andes/icons/Info16");
var Info16_default = /*#__PURE__*/__webpack_require__.n(Info16_namespaceObject);
;// ./src/ui/components/EmptyResult/index.jsx




const EmptyResult = () => {
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
      className: "result-list-empty-state",
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "result-title",
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
          children: i18n.gettext('No encontramos resultados para esta búsqueda')
        })
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: "empty-state-message",
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((Info16_default()), {
          className: "info-icon",
          width: "15.6px",
          height: "15.6px"
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
          children: [i18n.gettext('Revisa la ortografía de la palabra.'), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("br", {}), i18n.gettext('Utiliza palabras más genéricas o menos palabras.')]
        })]
      })]
    })
  });
};
;// external "@andes/badge"
const badge_namespaceObject = require("@andes/badge");
;// ./src/ui/components/ResultItem/index.jsx




const ResultItem = _ref => {
  let {
    result
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  if (!result || !Object.keys(result)) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: "result-item",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("a", {
      href: (result === null || result === void 0 ? void 0 : result.endpoint) || (result === null || result === void 0 ? void 0 : result.url),
      tabIndex: 0,
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "result-item__head",
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("h3", {
          children: [`${result === null || result === void 0 ? void 0 : result.title}`, !!(result !== null && result !== void 0 && result.section) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(badge_namespaceObject.Pill, {
            size: "small",
            color: "accent",
            hierarchy: "quiet",
            roundedCorners: ['top-right', 'top-left', 'bottom-right', 'bottom-left'],
            children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
              style: {
                height: '10px',
                display: 'flex',
                alignItems: 'center'
              },
              children: result.section
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "result-item__body",
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
          children: [i18n.gettext((result === null || result === void 0 ? void 0 : result.message) || '') || `${i18n.gettext('Saber más')}: ${result === null || result === void 0 ? void 0 : result.title}`, "..."]
        })
      })]
    })
  });
};
;// external "@andes/progress-indicator-linear"
const progress_indicator_linear_namespaceObject = require("@andes/progress-indicator-linear");
;// ./src/ui/utils/md-test-text.js
const mdTestText = `
__Markdown DEMO Message :)__

---

# h1 Heading 8-)
## h2 Heading
### h3 Heading
#### h4 Heading
##### h5 Heading
###### h6 Heading


## Horizontal Rules

___

---

***


## Typographic replacements

Enable typographer option to see result.

(c) (C) (r) (R) (tm) (TM) (p) (P) +-

test.. test... test..... test?..... test!....

!!!!!! ???? ,,  -- ---

"Smartypants, double quotes" and 'single quotes'


## Emphasis

**This is bold text**

__This is bold text__

*This is italic text*

_This is italic text_

~~Strikethrough~~


## Blockquotes


> Blockquotes can also be nested...
>> ...by using additional greater-than signs right next to each other...
> > > ...or with spaces between arrows.


## Lists

Unordered

+ Create a list by starting a line with \`+\`, \`-\`, or \`*\`
+ Sub-lists are made by indenting 2 spaces:
  - Marker character change forces new list start:
    * Ac tristique libero volutpat at
    + Facilisis in pretium nisl aliquet
    - Nulla volutpat aliquam velit
+ Very easy!

Ordered

1. Lorem ipsum dolor sit amet
2. Consectetur adipiscing elit
3. Integer molestie lorem at massa


4. You can use sequential numbers...
5. You can use sequential numbers...
6. You can use sequential numbers...
7. You can use sequential numbers...
8. You can use sequential numbers...
9. You can use sequential numbers...
10. You can use sequential numbers...
11. You can use sequential numbers...
12. ...or keep all the numbers as \`1.\`

Start numbering with offset:

56. foo
1. bar
2. baz


## Code

Inline \`code\`

Indented code

    // Some comments
    line 1 of code
    line 2 of code
    line 3 of code


Block code "fences"

\`\`\`
Sample text here... Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet
\`\`\`

Syntax highlighting

\`\`\` js
var foo = function (bar) {
  return bar++;
};

console.log(foo(5));
\`\`\`

## Tables

| Option | Description | Description |
| ------ | ----------- | ----------- |
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |

Right aligned columns

| Option | Description |
| ------:| -----------:|
| data   | path to data files to supply the data that will be passed into templates. |
| engine | engine to be used for processing templates. Handlebars is the default. |
| ext    | extension to be used for dest files. |

## Links

[link text](https://mercadopago.com.br/)

[link with title](https://mercadopago.com.br/ "title text!")

Autoconverted link https://mercadopago.com.br
`;
;// ./src/ui/components/ResultsAI/Content/index.jsx







const Content = _ref => {
  var _results$llm;
  let {
    term,
    lang,
    siteId,
    results,
    onProgressChange
  } = _ref;
  const {
    assistent
  } = useSearchClient();
  const defaultTitle = 'Resposta';
  const html = results === null || results === void 0 || (_results$llm = results.llm) === null || _results$llm === void 0 ? void 0 : _results$llm.html;
  const answerRef = (0,external_react_namespaceObject.useRef)(null);
  const [progress, setProgress] = (0,external_react_namespaceObject.useState)(0);
  const [title, setTitle] = (0,external_react_namespaceObject.useState)(defaultTitle);
  const titlefy = str => {
    const fallback = defaultTitle;
    try {
      return str ? str[0].toUpperCase() + str.substring(1) : fallback;
    } catch (_unused) {
      return fallback;
    }
  };
  const render = function (content) {
    let md = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const LLM = assistent({
      lang,
      site: siteId
    });
    LLM.renderAnswerAI(content, {
      md,
      target: answerRef === null || answerRef === void 0 ? void 0 : answerRef.current,
      fader: {
        speed: 150,
        onProgress: setProgress
      }
    });
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    var _results$query;
    render(html);
    setTitle(titlefy(term || (results === null || results === void 0 || (_results$query = results.query) === null || _results$query === void 0 ? void 0 : _results$query.text)));
  }, []);
  (0,external_react_namespaceObject.useEffect)(() => {
    if (onProgressChange) {
      onProgressChange(progress);
    }
  }, [progress]);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "search-result-ai__body",
    children: [progress < 100 && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "progress-container",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(progress_indicator_linear_namespaceObject.ProgressIndicatorLinear, {
        srAnnouncement: "Cargando...",
        srLabel: "Progreso de subida",
        value: progress
      })
    }), term.startsWith('__test:md') && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("textarea", {
      defaultValue: mdTestText,
      onBlur: e => render(e.target.value, true),
      style: {
        width: '100%',
        minHeight: '200px'
      },
      placeholder: "Markdown Debug Mode. Type something and perform a blur to test md capabilities."
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "search-result-ai__title",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
        children: title
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      ref: answerRef,
      className: "search-result-ai__answer"
    })]
  });
};
;// external "@andes/button"
const button_namespaceObject = require("@andes/button");
;// ./src/ui/components/ResultsAI/Feedback/IconCopy.jsx


const IconCopy = () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("g", {
    clipPath: "url(#clip0_2193_29771)",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6003 0.705078H5.01379V3.0867H6.21379V1.90508H13.4003V11.5032H12.789V12.7032H14.6003V0.705078ZM11.6121 4.29987H1.9917V16.3H11.6121V4.29987ZM3.1917 15.1V5.49987H10.4121V15.1H3.1917Z",
      fill: "black",
      fillOpacity: "0.25"
    })
  }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("defs", {
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("clipPath", {
      id: "clip0_2193_29771",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    })
  })]
});
;// ./src/ui/components/ResultsAI/Feedback/IconThumbDown.jsx


const IconThumbDown = () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.95698 11.0356L5.81814 11.37L8.38295 16.4999L9.39986 15.9912C10.7663 15.3076 11.4007 13.7063 10.8731 12.2724L10.5869 11.4946H13.3867C13.679 11.4946 13.9688 11.4412 14.2419 11.337C15.4804 10.8647 16.1015 9.47788 15.6292 8.2394L14.4243 5.07995C13.7029 3.18807 11.7343 2.08025 9.74269 2.44534L6.19669 3.09537H4.95698V1.89551H0.807617V12.0955H4.95698V11.0356ZM6.68432 10.4191L8.91902 14.8887C9.70002 14.4636 10.0561 13.5272 9.74691 12.6867L8.86681 10.2946H13.3867C13.5329 10.2946 13.6778 10.2679 13.8143 10.2158C14.4335 9.97966 14.7441 9.28622 14.508 8.66698L13.3031 5.50753C12.7878 4.15619 11.3816 3.36489 9.95907 3.62567L6.35941 4.28554L6.25123 4.29537H4.95698V9.74831L6.68432 10.4191ZM3.75682 3.09551H2.00762V10.8955H3.75698L3.75682 3.09551Z",
    fill: "black",
    fillOpacity: "0.25"
  })
});
;// ./src/ui/components/ResultsAI/Feedback/index.jsx










const {
  useState: Feedback_useState
} = (external_react_default());
function Feedback(_ref) {
  let {
    lang,
    id,
    siteId,
    answer
  } = _ref;
  const {
    assistent
  } = useSearchClient();
  const {
    config
  } = useConfig();
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const [feedbackGiven, setFeedbackGiven] = Feedback_useState(false);

  /**
   * Pass true for positive or false for negative Feedback
   *
   * @param {boolean} positive
   */
  function handleFeedbackClick(positive) {
    if (config !== null && config !== void 0 && config.onFeedback) {
      config.onFeedback({
        positive,
        id,
        siteId
      });
    }
    const LLMSDK = assistent({
      lang,
      site: siteId
    });
    LLMSDK.feedback(id, positive);
    setFeedbackGiven(true);
  }
  function copyToClipboard(content) {
    try {
      navigator.clipboard.writeText(content);
      if (config !== null && config !== void 0 && config.onCopyToClipboard) {
        config.onCopyToClipboard({
          content,
          id,
          siteId
        });
      }
    } catch (error) {
      console.error(error);
      if (config !== null && config !== void 0 && config.onCopyToClipboard) {
        config.onCopyToClipboard({
          error,
          id,
          siteId
        });
      }
    }
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: "search-result-ai__feedback",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(button_namespaceObject.Button, {
          size: "small",
          srLabel: "Copy",
          hierarchy: "transparent",
          title: i18n.gettext('Copiar'),
          onClick: () => copyToClipboard(answer),
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(IconCopy, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(button_namespaceObject.Button, {
          size: "small",
          srLabel: "Positive",
          "data-feedback-positive": true,
          hierarchy: "transparent",
          disabled: feedbackGiven,
          title: `Feedback: ${i18n.gettext('Sí')}`,
          onClick: () => handleFeedbackClick(true),
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(IconThumbDown, {})
        })
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(button_namespaceObject.Button, {
          size: "small",
          srLabel: "Negative",
          "data-feedback-negative": true,
          hierarchy: "transparent",
          disabled: feedbackGiven,
          "data-dylan-color": "orange",
          title: `Feedback: ${i18n.gettext('No')}`,
          onClick: () => handleFeedbackClick(false),
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(IconThumbDown, {})
        })
      })]
    })
  });
}
;// ./src/ui/components/ResultsAI/Footer/index.jsx


const Footer = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: "search-result-ai__footer",
    children: children
  });
};
;// external "core-js/modules/es.array.reduce.js"
const es_array_reduce_js_namespaceObject = require("core-js/modules/es.array.reduce.js");
;// external "core-js/modules/es.array.unshift.js"
const es_array_unshift_js_namespaceObject = require("core-js/modules/es.array.unshift.js");
;// external "core-js/modules/esnext.iterator.reduce.js"
const esnext_iterator_reduce_js_namespaceObject = require("core-js/modules/esnext.iterator.reduce.js");
;// external "core-js/modules/web.url.js"
const web_url_js_namespaceObject = require("core-js/modules/web.url.js");
;// external "core-js/modules/web.url.to-json.js"
const web_url_to_json_js_namespaceObject = require("core-js/modules/web.url.to-json.js");
;// ./src/ui/components/ResultsAI/RelatedLinks/helpers.js


















function product(urlStr) {
  const url = new URL(urlStr, 'https://test.com');
  const productArray = url.pathname.split('/').filter(item => {
    const prohibited = ['pt', 'es', 'en', 'docs', 'guides', 'reference', 'developers'];
    return item && !prohibited.includes(item);
  });
  return productArray[0] || '';
}
function noTrailingSlash(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.replace(/\/$/, '');
}
function isSamePathname(a, b) {
  const pathname = n => {
    var _URL;
    return noTrailingSlash((_URL = new URL(n, 'https://test.com')) === null || _URL === void 0 ? void 0 : _URL.pathname);
  };
  try {
    return pathname(a) === pathname(b);
  } catch (error) {
    console.error(error);
    return false;
  }
}
function mergeLinksAndSources(list, sources) {
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  try {
    if (!(list !== null && list !== void 0 && list.length) && !(sources !== null && sources !== void 0 && sources.length)) {
      return [];
    }
    if (!list || !Array.isArray(list)) {
      return mergeLinksAndSources([], sources, max);
    }
    sources.forEach(sourceItem => {
      const duplicated = (list === null || list === void 0 ? void 0 : list.length) && list.some(listItem => {
        var _noTrailingSlash, _noTrailingSlash2;
        const a = (_noTrailingSlash = noTrailingSlash(listItem === null || listItem === void 0 ? void 0 : listItem.endpoint)) === null || _noTrailingSlash === void 0 ? void 0 : _noTrailingSlash.toLowerCase();
        const b = (_noTrailingSlash2 = noTrailingSlash(sourceItem === null || sourceItem === void 0 ? void 0 : sourceItem.source)) === null || _noTrailingSlash2 === void 0 ? void 0 : _noTrailingSlash2.toLowerCase();
        if (a === b) {
          return true;
        }
        if (isSamePathname(a, b) || isSamePathname(b, a)) {
          return true;
        }
        return false;
      });
      if (!duplicated) {
        list.unshift({
          title: sourceItem.title,
          endpoint: sourceItem.source,
          section: sourceItem.section
        });
      }
    });
    return list.reduce((result, item) => {
      const hasSameSubject = result.some(check => {
        var _check$title, _item$title;
        return ((_check$title = check.title) === null || _check$title === void 0 ? void 0 : _check$title.trim()) === ((_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.trim()) && check.section === item.section;
      });
      const hasSameContent = item.content && result.some(check => check.content === item.content);
      if (hasSameSubject) {
        item.section = product(item.endpoint);
        if (!item.section || result.some(check => check.title === item.title && check.section === item.section)) {
          return result;
        }
      }
      const isSameLink = result.some(check => {
        return isSamePathname(check.endpoint, item.endpoint) || isSamePathname(item.endpoint, check.endpoint);
      });
      if (!hasSameContent && !isSameLink) {
        result.push(item);
      }
      return result;
    }, []).slice(0, max);
  } catch (error) {
    // the try catch is here for resilience purposes only, for ex:
    // an exception in the api that delivers null as an argument.
    // in ideal conditions this must not pass, but if happen we
    // return an empty array to avoid a render uncauth error
    console.error(error);
    return [];
  }
}
;// ./src/ui/components/ResultsAI/RelatedLinks/index.jsx








const MAX_RELATED_ITEMS = 10;
const RelatedLinks = _ref => {
  let {
    list,
    sources
  } = _ref;
  if (typeof document === typeof undefined) {
    return null;
  }
  const [expanded, setExpanded] = external_react_default().useState(false);
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  if (!(list !== null && list !== void 0 && list.length) && !(sources !== null && sources !== void 0 && sources.length)) {
    return null;
  }
  const toggleExpanded = e => {
    e.preventDefault();
    if (expanded) {
      const dropdown = document.querySelector('.search-dropdown');
      const ul = document.querySelector('.search-result-ai__related-links__list');
      if (dropdown && ul) {
        dropdown.scrollTop = ul.offsetTop - 46;
      }
    }
    setExpanded(!expanded);
  };

  /**
   * Sources are links sent by the AI telling us which page was used to the answer.
   * If sources sent, we add the sources as a list item to be rendered as reference.
   */
  const linklist = mergeLinksAndSources(list, sources, MAX_RELATED_ITEMS);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "search-result-ai__related-links",
    "data-expanded": expanded,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      "data-title": true /* className="search-result-ai__related-links__title" */,
      children: i18n.gettext('Para acceder a informaciones adicionales:')
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
      className: "search-result-ai__related-links__list",
      children: linklist.map(details => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("a", {
          tabIndex: 0,
          target: "_blank",
          href: details.endpoint,
          rel: "noopener noreferrer"
          // onClick={() => Tracker.send('mpdevelopers/search/click_on_related')}
          ,
          children: [i18n.gettext(details.title || ''), !!(details !== null && details !== void 0 && details.section) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(badge_namespaceObject.Pill, {
            size: "small",
            color: "accent",
            hierarchy: "quiet",
            roundedCorners: ['top-right', 'top-left', 'bottom-right', 'bottom-left'],
            children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
              style: {
                height: '10px',
                display: 'flex',
                alignItems: 'center'
              },
              children: i18n.gettext(details.section)
            })
          })]
        }, details.endpoint)
      }))
    }), linklist.length > 5 && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      href: "#",
      role: "button",
      className: "links-more-less",
      onClick: toggleExpanded,
      "data-icon": expanded ? '-' : '+',
      children: expanded ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: i18n.gettext('Ver menos')
      }) : /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: i18n.gettext('Ver más')
      })
    })]
  });
};
;// external "@andes/icons/Search24"
const Search24_namespaceObject = require("@andes/icons/Search24");
var Search24_default = /*#__PURE__*/__webpack_require__.n(Search24_namespaceObject);
;// external "@andes/icons/ChevronRight12"
const ChevronRight12_namespaceObject = require("@andes/icons/ChevronRight12");
var ChevronRight12_default = /*#__PURE__*/__webpack_require__.n(ChevronRight12_namespaceObject);
;// ./src/ui/components/ResultsAI/Suggestions/index.jsx







const Suggestions = _ref => {
  let {
    items,
    max,
    onClickSuggestion
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const MAX_ITEMS = max || 5;
  if (!items || !Array.isArray(items) || !items.length) {
    return null;
  }
  const handleSuggestionClick = item => {
    if (onClickSuggestion) {
      onClickSuggestion(item);
    }
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "suggestions",
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "suggestions__head",
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
        children: i18n.gettext('BÚSQUEDAS RELACIONADAS')
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
      className: "suggestions__list",
      children: items.slice(0, MAX_ITEMS).map(item => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("li", {
        className: "suggestions__list__item",
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(button_namespaceObject.Button, {
          hierarchy: "transparent",
          onClick: () => handleSuggestionClick(item),
          children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((Search24_default()), {
            color: "rgba(0, 158, 227, 1)"
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            className: "suggestions__list__item__label",
            children: item
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((ChevronRight12_default()), {
            color: "rgba(0, 0, 0, 0.55)"
          })]
        }, item)
      }))
    })]
  });
};
;// ./src/ui/components/ResultsAI/index.jsx









const ResultsAI = _ref => {
  var _results$llm, _results$llm2, _results$llm3, _results$llm4, _results$llm5;
  let {
    term,
    siteId,
    results,
    lang,
    onClickSuggestion
  } = _ref;
  const [showAfterContent, setShowAfterContent] = external_react_default().useState(false);
  const showRelatedLinks = !(results !== null && results !== void 0 && (_results$llm = results.llm) !== null && _results$llm !== void 0 && _results$llm.bot_not_respond);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "search-result-ai",
    tabIndex: 0,
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Content, {
      term: term,
      lang: lang,
      siteId: siteId,
      results: results,
      onProgressChange: n => setShowAfterContent(n >= 90)
    }), showAfterContent && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
      children: [showRelatedLinks && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(RelatedLinks, {
        list: (results === null || results === void 0 ? void 0 : results.classic) || [],
        sources: (results === null || results === void 0 || (_results$llm2 = results.llm) === null || _results$llm2 === void 0 ? void 0 : _results$llm2.sources) || []
      }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Feedback, {
        lang: lang,
        id: results === null || results === void 0 || (_results$llm3 = results.llm) === null || _results$llm3 === void 0 ? void 0 : _results$llm3.id,
        siteId: siteId,
        answer: results.llm.answer
      }), (results === null || results === void 0 || (_results$llm4 = results.llm) === null || _results$llm4 === void 0 ? void 0 : _results$llm4.suggestions) && (results === null || results === void 0 || (_results$llm5 = results.llm) === null || _results$llm5 === void 0 ? void 0 : _results$llm5.suggestions.length) > 0 && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Footer, {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Suggestions, {
          max: 10,
          onClickSuggestion: onClickSuggestion,
          items: results.llm.suggestions
        })
      })]
    })]
  });
};
;// ./src/ui/components/SearchResults/index.jsx








let itemId = 0;
const SearchResults = _ref => {
  var _results$classic;
  let {
    results,
    showResults,
    term,
    lang,
    siteId,
    loading,
    empty,
    hasAIAnswer,
    isMobile,
    onClickSuggestion
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [loading && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(LoadingSpinner, {}), !loading && showResults && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
        className: "result-box-header",
        children: hasAIAnswer ? i18n.gettext('BÚSQUEDA INTELIGENTE') : i18n.gettext('Resultado de búsqueda')
      }), empty && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(EmptyResult, {
        i18n: i18n
      }), !empty && (hasAIAnswer ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(ResultsAI, {
        term: term,
        lang: lang,
        siteId: siteId,
        results: results,
        onClickSuggestion: onClickSuggestion
      }) : results === null || results === void 0 || (_results$classic = results.classic) === null || _results$classic === void 0 ? void 0 : _results$classic.map(item => {
        itemId += 1;
        return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(ResultItem, {
          isMobile: isMobile,
          siteId: siteId,
          result: item,
          lang: lang,
          i18n: i18n
        }, itemId);
      }))]
    })]
  });
};
;// ./src/ui/components/SearchHistory/UserHistory/index.jsx




let incid = 0;
const UserHistory = _ref => {
  let {
    items,
    title,
    onClickItem
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const except = result => {
    var _result$llm, _result$classic;
    const answer = result === null || result === void 0 || (_result$llm = result.llm) === null || _result$llm === void 0 ? void 0 : _result$llm.answer;
    if (answer) {
      return `${answer.substring(0, 200)}...`;
    }
    return i18n.gettext('Resultados disponibles: {0}?', result === null || result === void 0 || (_result$classic = result.classic) === null || _result$classic === void 0 ? void 0 : _result$classic.length);
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "result-list-wrapper",
    children: [Boolean(title) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      className: "result-box-header",
      style: {
        marginTop: 0
      },
      children: title
    }), items.map(item => {
      return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
        tabIndex: 0,
        className: "result-item",
        style: {
          cursor: 'pointer'
        },
        onClick: () => onClickItem && onClickItem(item),
        children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
          className: "result-item__head",
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
            children: item.query.text
          })
        }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
          className: "result-item__body",
          children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
            children: except(item)
          })
        })]
      }, ++incid);
    })]
  });
};
;// external "@andes/tabs"
const tabs_namespaceObject = require("@andes/tabs");
;// ./src/ui/components/SearchHistory/CommunityHistory/index.jsx




const CommunityHistory = _ref => {
  let {
    items,
    title,
    isMobile
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: "result-list-wrapper",
    children: [Boolean(title) && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      className: "result-box-header",
      style: {
        marginTop: 0
      },
      children: title
    }), items.map(() => {
      return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "result-item",
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("a", {
          href: "/",
          children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            className: "result-item__head",
            children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h3", {
              children: !isMobile && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(badge_namespaceObject.Pill, {
                size: "small",
                color: "accent",
                hierarchy: "quiet",
                roundedCorners: ['top-right', 'top-left', 'bottom-right', 'bottom-left'],
                children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
                  style: {
                    height: '10px',
                    display: 'flex',
                    alignItems: 'center'
                  }
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            className: "result-item__body",
            children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {})
          })]
        })
      });
    })]
  });
};
;// ./src/ui/components/SearchHistory/TabsHistory/index.jsx






const TabsHistory = _ref => {
  let {
    history,
    isMobile,
    onClickUserHistoryItem
  } = _ref;
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(tabs_namespaceObject.Tabs, {
    className: "tabs",
    id: "tabs-id",
    srLabel: "Custom handler label",
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(tabs_namespaceObject.Tab, {
      title: i18n.gettext('Búsquedas Recientes'),
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(tabs_namespaceObject.TabContent, {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(UserHistory, {
          isMobile: isMobile,
          items: history === null || history === void 0 ? void 0 : history.user,
          onClickItem: onClickUserHistoryItem
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(tabs_namespaceObject.Tab, {
      title: i18n.gettext('Más buscadas'),
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(tabs_namespaceObject.TabContent, {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CommunityHistory, {
          isMobile: isMobile,
          items: history === null || history === void 0 ? void 0 : history.user
        })
      })
    })]
  });
};
;// ./src/ui/components/SearchHistory/index.jsx










const SearchHistory = _ref => {
  let {
    isMobile,
    onClickUserHistoryItem
  } = _ref;
  const {
    userSearchHistory
  } = useSearchClient();
  const {
    i18n
  } = (0,external_frontend_i18n_namespaceObject.useI18n)();
  const [history, setHistory] = (0,external_react_namespaceObject.useState)({});
  const [loading, setLoading] = (0,external_react_namespaceObject.useState)(true);
  const hasUserHistory = () => {
    var _history$user;
    return Boolean(history === null || history === void 0 || (_history$user = history.user) === null || _history$user === void 0 ? void 0 : _history$user.length);
  };
  const hasCommunityHistory = () => {
    var _history$community;
    return Boolean(history === null || history === void 0 || (_history$community = history.community) === null || _history$community === void 0 ? void 0 : _history$community.length);
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    setHistory({
      community: [],
      user: userSearchHistory()
    });
    setLoading(false);
  }, []);
  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(LoadingSpinner, {});
  }
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
    children: [hasUserHistory() && !hasCommunityHistory() && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(UserHistory, {
      title: i18n.gettext('Búsquedas Recientes'),
      isMobile: isMobile,
      items: history === null || history === void 0 ? void 0 : history.user,
      onClickItem: onClickUserHistoryItem,
      i18n: i18n
    }), hasCommunityHistory() && !hasUserHistory() && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CommunityHistory, {
      title: i18n.gettext('Más buscadas'),
      isMobile: isMobile,
      items: history === null || history === void 0 ? void 0 : history.community
    }), hasUserHistory() && hasCommunityHistory() && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(TabsHistory, {
      i18n: i18n,
      history: history,
      isMobile: isMobile,
      onClickUserHistoryItem: onClickUserHistoryItem
    })]
  });
};
;// ./src/ui/components/DebugDetails/index.jsx


const DebugDetails = () => {
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    style: {
      fontSize: 12
    },
    children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "DEBUG HELP: This is visible only in Development Mode. Keywords to Front End test AI Search Bar:"
      })
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:*"
      }), " If you start a question with __test:, the lib will simulate a successful answer and will not send a real request to the LLM-AI."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:error"
      }), " If you start a question with __test:error, the lib will simulate an error and will not send a real request to the LLM-AI."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:timeout"
      }), " If you start a question with __test:timeout, the lib will simulate a timeout will not send a real request to the LLM-AI."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:empty"
      }), " If you start a question with __test:empty, the lib will simulate a timeout will not send a real request to the LLM-AI."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:ambiguous"
      }), " If you start a question with __test:ambiguous, the lib will simulate an ambiguous flag answer from the API and will not send a real request to the LLM-AI."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__test:md"
      }), " Enter markdown debug mode, very useful to debug markdown and rendering capabilities."]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__suggestions!"
      }), " Add this key to any part of a question to force suggestions generations for the keywords on this question"]
    }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("p", {
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("strong", {
        children: "__query!"
      }), " Add this key to any part of a question to receive on the response the Query payload generated by the BFF that was sent to the AI API"]
    })]
  });
};
;// ./src/ui/hooks/useOnScroll.jsx

function useOnScroll(callback, deps) {
  (0,external_react_namespaceObject.useEffect)(() => {
    window.addEventListener('scroll', callback);
    return () => window.removeEventListener('scroll', callback);
  }, deps);
}
;// ./src/ui/components/SearchBarRoot/index.jsx
function SearchBarRoot_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SearchBarRoot_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SearchBarRoot_ownKeys(Object(t), !0).forEach(function (r) { SearchBarRoot_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SearchBarRoot_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SearchBarRoot_defineProperty(e, r, t) { return (r = SearchBarRoot_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function SearchBarRoot_toPropertyKey(t) { var i = SearchBarRoot_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function SearchBarRoot_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


















const SearchBarRoot = props => {
  if (typeof window === typeof undefined) {
    return null;
  }
  const $el = (0,external_react_namespaceObject.useRef)();
  const {
    config
  } = useConfig();
  const {
    assistent,
    isAIEnabled
  } = useSearchClient();
  const {
    lang,
    isMobile,
    siteId,
    layout,
    placeholder,
    portal,
    dropdownQuestionInput
  } = props;
  if (portal && !layout === 'fixed') {
    console.warn('Dx SearchBar AI: when using portal you must set the layout property to "fixed" in order to avoid positioning problems.');
  }
  const [term, setTerm] = (0,external_react_namespaceObject.useState)('');
  const [active, setActive] = (0,external_react_namespaceObject.useState)(false);
  const [results, setResults] = (0,external_react_namespaceObject.useState)({});
  const [empty, setEmpty] = (0,external_react_namespaceObject.useState)(true);
  const [loading, setLoading] = (0,external_react_namespaceObject.useState)(false);
  const [hasAIAnswer, setHasAIAnswer] = (0,external_react_namespaceObject.useState)(false);
  const [showResults, setShowResults] = (0,external_react_namespaceObject.useState)(false);
  const [loadingHistory, setLoadingHistory] = (0,external_react_namespaceObject.useState)(false);
  const transport = component => {
    if (typeof window !== 'undefined' && portal) {
      const content = /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        className: "search-ai-holder",
        "data-transported": "true",
        children: component
      });
      const target = document.querySelector(portal);
      if (!target) {
        return component;
      }
      return /*#__PURE__*/(0,external_react_dom_namespaceObject.createPortal)(content, target);
    }
    return component;
  };
  const reset = () => {
    setShowResults(false);
    setLoading(false);
    setEmpty(true);
    setResults({});
  };
  const forceInputValue = v => {
    const holder = portal ? $el === null || $el === void 0 ? void 0 : $el.current.getRootNode().querySelector(portal) : $el.current;
    const input = holder === null || holder === void 0 ? void 0 : holder.querySelector('[name=ai-search-input]');
    if (input) {
      input.value = v;
      input.dispatchEvent(new Event('input', {
        bubbles: true,
        cancelable: true
      }));
    }
  };
  const loadHistoryItem = item => {
    reset();
    setLoadingHistory(true);
    setLoading(true);
    setShowResults(true);
    setResults(item);
    forceInputValue(item === null || item === void 0 ? void 0 : item.query.text);
    setTimeout(() => {
      setLoading(false);
      if (config !== null && config !== void 0 && config.onLoadUserHistory) {
        config.onLoadUserHistory({
          item,
          lang,
          siteId
        });
      }
    }, 600);
  };
  const onBackdropClick = () => {
    reset();
    setActive(false);
    forceInputValue('');
  };
  const doSearch = function () {
    let inputTerm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : term;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (loadingHistory) {
      return false;
    }
    reset();
    setShowResults((inputTerm === null || inputTerm === void 0 ? void 0 : inputTerm.length) > 2);
    if ((inputTerm === null || inputTerm === void 0 ? void 0 : inputTerm.length) > 2) {
      setLoading(true);
      if (config !== null && config !== void 0 && config.onSearchStart) {
        config.onSearchStart({
          inputTerm,
          lang,
          siteId
        });
      }
      const LLM = assistent({
        lang,
        site: siteId
      });
      const startTime = new Date().getTime();
      LLM.ask(inputTerm, options).question.then(resp => {
        if (config !== null && config !== void 0 && config.onSuccess) {
          config.onSuccess({
            term: inputTerm,
            lang,
            siteId
          });
        }
        if (config !== null && config !== void 0 && config.onAiAnswer && resp.llm.html) {
          config.onAiAnswer({
            term: inputTerm,
            lang,
            siteId
          });
        }
        if (config !== null && config !== void 0 && config.onClassicAnswer && resp.classic.length) {
          var _resp$classic;
          config.onClassicAnswer({
            term: inputTerm,
            lang,
            siteId,
            amount: resp === null || resp === void 0 || (_resp$classic = resp.classic) === null || _resp$classic === void 0 ? void 0 : _resp$classic.length
          });
        }
        setResults(resp);
      }).catch(error => {
        console.error(error);
        if (config !== null && config !== void 0 && config.onError) {
          config.onError({
            message: error === null || error === void 0 ? void 0 : error.message
          });
        }
      }).finally(() => {
        const endTime = new Date().getTime();
        const responseTime = (endTime - startTime) / 1000;
        if (config !== null && config !== void 0 && config.onDone) {
          var _results$llm, _results$classic;
          config.onDone({
            term: inputTerm,
            hasAIAnswer: Boolean(results === null || results === void 0 || (_results$llm = results.llm) === null || _results$llm === void 0 ? void 0 : _results$llm.html),
            hasClassicAnswer: Boolean(results === null || results === void 0 || (_results$classic = results.classic) === null || _results$classic === void 0 ? void 0 : _results$classic.length),
            responseTime
          });
        }
        setLoading(false);
      });
    }
    return true;
  };
  const loadSuggestionItem = item => {
    if (config !== null && config !== void 0 && config.onClickSuggestion) {
      config.onClickSuggestion({
        item
      });
    }
    forceInputValue(item);
    doSearch(item, {
      was_suggestion: true
    });
  };
  const listenToCloseOnESC = () => {
    if (typeof window !== 'undefined') {
      const eventAction = active ? 'addEventListener' : 'removeEventListener';
      if (!window.dxclosesearchbar) {
        window.dxclosesearchbar = e => {
          if (e.key === 'Escape') {
            setActive(false);
            reset();
            forceInputValue('');
            const input = $el === null || $el === void 0 ? void 0 : $el.current.querySelector('[name=ai-search-input]');
            if (input) {
              input.blur();
            }
          }
        };
      }
      window[eventAction]('keydown', window.dxclosesearchbar);
      if (!active) {
        window.dxclosesearchbar = null;
      }
    }
  };
  (0,external_react_namespaceObject.useEffect)(() => {
    var _results$llm2, _results$classic2, _results$llm3;
    setHasAIAnswer(results === null || results === void 0 || (_results$llm2 = results.llm) === null || _results$llm2 === void 0 ? void 0 : _results$llm2.html);
    setEmpty(!(results !== null && results !== void 0 && (_results$classic2 = results.classic) !== null && _results$classic2 !== void 0 && _results$classic2.length) && !(results !== null && results !== void 0 && (_results$llm3 = results.llm) !== null && _results$llm3 !== void 0 && _results$llm3.html));
  }, [results]);
  (0,external_react_namespaceObject.useEffect)(() => {
    if (isAIEnabled(siteId)) {
      if (term.length < 3) {
        reset();
      }
    } else {
      doSearch();
    }
    if (loadingHistory) {
      setLoadingHistory(false);
    }
  }, [term]);
  (0,external_react_namespaceObject.useEffect)(() => {
    if (config !== null && config !== void 0 && config.onSearchToggle) {
      config.onSearchToggle({
        active
      });
    }
    if (active && dropdownQuestionInput && $el !== null && $el !== void 0 && $el.current) {
      const $input = $el === null || $el === void 0 ? void 0 : $el.current.querySelector('[name=ai-search-input]');
      $input === null || $input === void 0 || $input.focus();
    }
    listenToCloseOnESC();
  }, [active]);
  useOnScroll(e => {
    if (active && $el.current) {
      const $searchBox = $el.current.querySelector('.search-dropdown');
      const searchBoxRect = $searchBox.getBoundingClientRect();
      if (searchBoxRect.y * -1 > searchBoxRect.height) {
        var _document$querySelect;
        reset();
        setActive(false);
        forceInputValue('');
        (_document$querySelect = document.querySelector(':focus')) === null || _document$querySelect === void 0 || _document$querySelect.blur();
      }
    }
  }, [active]);
  const InputQuestion = function () {
    for (var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++) {
      overrides[_key] = arguments[_key];
    }
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchInput, SearchBarRoot_objectSpread({
      siteId: siteId,
      layout: layout,
      onTyped: setTerm,
      isActive: active,
      onSubmit: doSearch,
      placeholder: placeholder,
      onFocus: e => {
        setActive(true);
        if (config !== null && config !== void 0 && config.onFocusInput) {
          config.onFocusInput(e);
        }
      },
      allowSearching: (term === null || term === void 0 ? void 0 : term.length) > 2
    }, overrides));
  };
  const InputToggler = () => /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchInput, {
    maxLength: 0,
    siteId: siteId,
    isActive: active,
    onSubmit: () => {},
    placeholder: placeholder,
    name: "search-input-toggler",
    onFocus: e => setActive(true)
  });
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    "data-layout": layout,
    className: "search-ai-holder",
    "data-ai-search-root-div": "true",
    "data-active": !!active,
    ref: $el,
    "data-transported": Boolean(portal),
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      className: "search-container",
      "data-auto-hide": !active && Boolean(portal),
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
        className: "search-container__content",
        children: [transport(dropdownQuestionInput ? InputToggler() : InputQuestion()), active && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
          className: "search-dropdown",
          style: {
            maxHeight: `${props.maxBoxVH || 60}vh`
          },
          children: [dropdownQuestionInput && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            className: "search-dropdown__input",
            tabIndex: 0,
            children: InputQuestion()
          }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
            className: "search-dropdown__content",
            tabIndex: 0,
            children: [term === '__' && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(DebugDetails, {}), showResults && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchResults, {
              term: term,
              lang: lang,
              empty: empty,
              siteId: siteId,
              results: results,
              loading: loading,
              isMobile: isMobile,
              showResults: showResults,
              hasAIAnswer: hasAIAnswer,
              onClickSuggestion: loadSuggestionItem
            }), !showResults && term === '' && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchHistory, {
              isMobile: isMobile,
              onClickUserHistoryItem: loadHistoryItem
            })]
          })]
        }), active && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
          onClick: onBackdropClick,
          className: "search-backdrop"
        })]
      })
    })
  });
};
;// ./src/ui/utils/i18n-configure.js

function getTranslations() {
  if (typeof window !== typeof undefined) {
    var _window$__PRELOADED_S;
    return ((_window$__PRELOADED_S = window.__PRELOADED_STATE__) === null || _window$__PRELOADED_S === void 0 ? void 0 : _window$__PRELOADED_S.translations) || {};
  }
  return {};
}
const i18n = new external_frontend_i18n_namespaceObject.I18n({
  translations: getTranslations()
});
;// ./src/ui/index.js




function ui_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ui_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ui_ownKeys(Object(t), !0).forEach(function (r) { ui_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ui_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ui_defineProperty(e, r, t) { return (r = ui_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ui_toPropertyKey(t) { var i = ui_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ui_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






const SearchBar = props => {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    className: "dx-search-bar-ai",
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(ConfigProvider, ui_objectSpread(ui_objectSpread({}, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(external_frontend_i18n_namespaceObject.I18nProvider, {
        i18n: i18n,
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(SearchBarRoot, ui_objectSpread({}, props))
      })
    }))
  });
};
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.js.map